import * as TYPES from './types'

export default {
  [TYPES.MAIN_SET_LANGUAGE] (state, lang) {
    state.language = lang
  }
}
